export default {
  test: 'test',
  hello: 'hello',
  Username: 'Username',
  logout_label: 'Logout',
}
